<template>
<section class="advantages-section">
  <div class="app">
    <Advantages :image="image" :infoBlocks="blocos" />
  </div>
</section>
</template>

<script setup>

import "@/assets/scss/custom/triplea/components/_advantages_section.scss"
import image from '@/assets/img/triplea/home/advantages/rodape-image.png'
import Advantages from './Advantages.vue';





const blocos = [
  {
    title: 'Flexibilidade',
    text: 'Mude para o extraordinário com imóveis que redefinem o conceito de luxo. Sua oportunidade de viver com exclusividade está a um passo de distância!'
  },
  {
    title: 'Rentabilidade',
    text: 'Mude para o extraordinário com imóveis que redefinem o conceito de luxo. Sua oportunidade de viver com exclusividade está a um passo de distância!'
  },
  {
    title: 'Diversificação',
    text: 'Mude para o extraordinário com imóveis que redefinem o conceito de luxo. Sua oportunidade de viver com exclusividade está a um passo de distância!'
  },
  {
    title: 'Valorização',
    text: 'Mude para o extraordinário com imóveis que redefinem o conceito de luxo. Sua oportunidade de viver com exclusividade está a um passo de distância!'
  }
]
</script>


